import { DataType } from "../../../enums/dataType";
import { FieldType } from "../../../enums/fieldType";

class FieldDto {

    public id: string;

    public label: string;

    public helpText: string;

    public isSensitive: boolean;

    public fieldType: FieldType;

    public dataType: DataType;

    public customerProfileFieldId: string;

    public dataReference: string;

    public validationConditions: any[] = [];

    public displayTriggers: any[] = [];

    public crmGroup: string;

    public crmMetric: string;
}

export { FieldDto };